import { MasterUseCaseInterface } from 'application/usecases/MasterUseCase';
import IconNext from 'assets/icons/chevron-right-small.svg';
import { openErrorNoti } from 'presentation/components/Notification';
import { PageTitle } from 'presentation/components/PageTitle';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { MasterAreaData } from './models/Master';

interface props {
    masterUseCase: MasterUseCaseInterface;
}

export const AREA_CODE = 'areaCode';
export const AREA_ID = 'areaId';

const CU05502Page = ({ masterUseCase }: props) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [masterArea, setMasterArea] = useState<MasterAreaData[]>([]);

    useEffect(() => {
        (async () => {
            try {
                dispatch(startFetching());
                const response = await masterUseCase.getMasterAreasSearchAreas();
                setMasterArea(response);
            } catch (error: any) {
                openErrorNoti();
            } finally {
                dispatch(completeFetching());
            }
        })();
    }, []);
    const onClickFilterArea = (areaCode: number, areaId: number) => {
        navigate(
            `${PRIVATE_ROUTES.PATH}/${
                PRIVATE_ROUTES.SUB.CU_055_03
            }?${`${AREA_CODE}=${areaCode}`}&${`${AREA_ID}=${areaId}`}`,
        );
    };
    return (
        <section
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexFlow: 'column',
            }}
            className="CU-055-02-container"
        >
            <PageTitle title="エリアを選択" />
            <section
                style={{
                    height: '100%',
                    overflow: 'auto',
                    flexGrow: 1,
                }}
            >
                <section style={{ width: 710 }}>
                    <div className="title-card-area" style={{ marginBottom: 24 }}>
                        エリアを選択してください
                    </div>
                    <div className="card-area">
                        {masterArea &&
                            masterArea.map((element: MasterAreaData) => {
                                return (
                                    <div
                                        className="card-area-item glow-on-hover"
                                        key={element.id}
                                        onClick={() => onClickFilterArea(element.code, element.id)}
                                    >
                                        <div className="card-area-item-content">
                                            <div className="label-item">{element.name}</div>
                                            <div className="number-item">
                                                {element.numberProperty}
                                            </div>
                                        </div>
                                        <div>
                                            <img src={IconNext} />
                                        </div>
                                    </div>
                                );
                            })}
                    </div>
                </section>
            </section>
        </section>
    );
};

export default CU05502Page;
